import { Injectable } from '@angular/core';
import { retry } from 'rxjs/operators';

export interface ITimeEntryLine {
  TimeTaskID: number;
  days: ITimeEntryDay[];
}

export interface ITimeEntryDay {
  date: Date;
  detail: ITimeEntryDetail;
}

export interface ITimeEntryDetail {
  hours: number;
  locked: boolean;
  note: string;
}

let lines: ITimeEntryLine[] = [];

export class Company {
  ID: number;
  DealType: string;
  Address: string;
  Product: string;
  Obligor: string;
  Zipcode: number;
  CreatedBy: string;
  Status: string;
  Website: string;
}
let companies: Company[] = [{
  "ID": 1,
  "DealType": "High Income Fund",
  "Address": "7601 Penn Avenue South",
  "Product": "Richfield",
  "Obligor": "Minnesota",
  "Zipcode": 55423,
  "CreatedBy": "Eric",
  "Status": "Approved",
  "Website": "http =//www.nowebsitepremierbuy.com"
}, {
  "ID": 2,
  "DealType": "Standard Deal",
  "Address": "263 Shuman Blvd",
  "Product": "Naperville",
  "Obligor": "Illinois",
  "Zipcode": 60563,
  "CreatedBy": "Santosh",
  "Status": "Approved",
  "Website": "http =//www.nowebsiteelectrixmax.com"
}, {
  "ID": 3,
  "DealType": "High Income Fund",
  "Address": "1201 Elm Street",
  "Product": "Dallas",
  "Obligor": "Texas",
  "Zipcode": 75270,
  "CreatedBy": "Jeremy",
  "Status": "Pending",
  "Website": "http =//www.nowebsitevideoemporium.com"
}, {
  "ID": 4,
  "DealType": "Standard Deal",
  "Address": "1000 Lowes Blvd",
  "Product": "Mooresville",
  "Obligor": "North Carolina",
  "Zipcode": 28117,
  "CreatedBy": "Eric",
  "Status": "Cancelled",
  "Website": "http =//www.nowebsitescreenshop.com"
}, {
  "ID": 5,
  "DealType": "High Income Fund",
  "Address": "1 Infinite Loop",
  "Product": "Cupertino",
  "Obligor": "California",
  "Zipcode": 95014,
  "CreatedBy": "Jeremy",
  "Status": "Pending",
  "Website": "http =//www.nowebsitebraeburn.com"
}, {
  "ID": 6,
  "DealType": "Standard Deal",
  "Address": "30 Hunter Lane",
  "Product": "Camp Hill",
  "Obligor": "Pennsylvania",
  "Zipcode": 17011,
  "CreatedBy": "Riyaz",
  "Status": "Pending",
  "Website": "http =//www.nowebsitepriceco.com"
}, {
  "ID": 7,
  "DealType": "Green Light",
  "Address": "1557 Watson Blvd",
  "Product": "Warner Robbins",
  "Obligor": "Georgia",
  "Zipcode": 31093,
  "CreatedBy": "Jeremy",
  "Status": "Pending",
  "Website": "http =//www.nowebsiteultimategadget.com"
}, {
  "ID": 8,
  "DealType": "Standard Deal",
  "Address": "618 Michillinda Ave.",
  "Product": "Arcadia",
  "Obligor": "California",
  "Zipcode": 91007,
  "CreatedBy": "Jeremy",
  "Status": "Pending",
  "Website": "http =//www.nowebsiteezstop.com"
}, {
  "ID": 9,
  "DealType": "High Income Fund",
  "Address": "1100 W. Artesia Blvd.",
  "Product": "Compton",
  "Obligor": "California",
  "Zipcode": 90220,
  "CreatedBy": "Riyaz",
  "Status": "Pending",
  "Website": "http =//www.nowebsiteclicker.com"
}, {
  "ID": 10,
  "DealType": "High Income Fund",
  "Address": "2401 Utah Ave. South",
  "Product": "Seattle",
  "Obligor": "Washington",
  "Zipcode": 98134,
  "CreatedBy": "Eric",
  "Status": "Approved",
  "Website": "http =//www.nowebsiteamerica.com"
}, {
  "ID": 11,
  "DealType": "Standard Deal",
  "Address": "1945 S Cienega Boulevard",
  "Product": "Los Angeles",
  "Obligor": "California",
  "Zipcode": 90034,
  "CreatedBy": "Eric",
  "Status": "Approved",
  "Website": "http =//www.nowebsitezonetoys.com"
}, {
  "ID": 12,
  "DealType": "Standard Deal",
  "Address": "2525 E El Segundo Blvd",
  "Product": "El Segundo",
  "Obligor": "California",
  "Zipcode": 90245,
  "CreatedBy": "Eric",
  "Status": "Approved",
  "Website": "http =//www.nowebsiteacme.com"
}, {
  "ID": 13,
  "DealType": "Standard Deal",
  "Address": "702 SW 8th Street",
  "Product": "Bentonville",
  "Obligor": "Arkansas",
  "Zipcode": 72716,
  "CreatedBy": "Eric",
  "Status": "Approved",
  "Website": "http://www.nowebsitesupermart.com"
}, {
  "ID": 14,
  "DealType": "Green Light",
  "Address": "2455 Paces Ferry Road NW",
  "Product": "Atlanta",
  "Obligor": "Georgia",
  "Zipcode": 30339,
  "CreatedBy": "Eric",
  "Status": "Approved",
  "Website": "http =//www.nowebsitedepot.com"
}, {
  "ID": 15,
  "DealType": "Green Light",
  "Address": "1000 Nicllet Mall",
  "Product": "Minneapolis",
  "Obligor": "Minnesota",
  "Zipcode": 55403,
  "CreatedBy": "Jeremy",
  "Status": "Approved",
  "Website": "http =//www.nowebsitemusic.com"
}, {
  "ID": 16,
  "DealType": "Green Light",
  "Address": "999 Lake Drive",
  "Product": "Issaquah",
  "Obligor": "Washington",
  "Zipcode": 98027,
  "CreatedBy": "Santosh",
  "Status": "Cancelled",
  "Website": "http =//www.nowebsitetomsclub.com"
}, {
  "ID": 17,
  "DealType": "Green Light",
  "Address": "3333 Beverly Rd",
  "Product": "Hoffman Estates",
  "Obligor": "Illinois",
  "Zipcode": 60179,
  "CreatedBy": "Santosh",
  "Status": "Pending",
  "Website": "http =//www.nowebsiteemart.com"
}, {
  "ID": 18,
  "DealType": "Green Light",
  "Address": "200 Wilmot Rd",
  "Product": "Deerfield",
  "Obligor": "Illinois",
  "Zipcode": 60015,
  "CreatedBy": "Santosh",
  "Status": "Cancelled",
  "Website": "http =//www.nowebsitewalters.com"
}, {
  "ID": 19,
  "DealType": "Green Light",
  "Address": "400 Commerce S",
  "Product": "Fort Worth",
  "Obligor": "Texas",
  "Zipcode": 76102,
  "CreatedBy": "Santosh",
  "Status": "Approved",
  "Website": "http =//www.nowebsiteshack.com"
}, {
  "ID": 20,
  "DealType": "High Income Fund",
  "Address": "2200 Kensington Court",
  "Product": "Oak Brook",
  "Obligor": "Illinois",
  "Zipcode": 60523,
  "CreatedBy": "Santosh",
  "Status": "Approved",
  "Website": "http =//www.nowebsitecircuittown.com"
}];


export class Column {
  Name: string;
  Value: string;
}

export class WFInstance {
  InstanceId: number;
  columns: Column[];
}

let WFInstances: WFInstance[] = [];

export class WFItemSource {
  ID: number;
  Name: string;
}

export class BusinessProcessInstanceStateData {
  DataCaption: string;
  DataType: string;
  Value: string;
  ItemSource: WFItemSource[];
}

export class WorkFlowTab {
  ID: number;
  Name: string;
  DisplayOrder: number;
}


let WorkFlowTabs: WorkFlowTab[] = [{
  "ID": 1,
  "Name": "General",
  "DisplayOrder": 0
}

]

let BusinessProcessInstanceStateDatas: BusinessProcessInstanceStateData[] = [];

@Injectable()
export class Service {

  constructor() {
    for (var j: number = 0; j < 1; j++) {
      let days: ITimeEntryDay[] = [];
      for (var i: number = 0; i < 5; i++) {
        days.push({
          date: new Date(2018, 5, i),
          detail: {
            hours: i,
            locked: false,
            note: ''
          }
        });
      }
      lines.push({
        TimeTaskID: j,
        days: days
      });
    }


    let Columns: Column[] = [];

    Columns.push({
      Name: "Employee",
      Value: "Charles"
    });

    Columns.push({
      Name: "Designation",
      Value: "Engineer"
    });

    WFInstances.push({
      InstanceId: 1,
      columns: Columns
    });


    let Columns2: Column[] = [];

    Columns2.push({
      Name: "Employee",
      Value: "Venkat"
    });

    Columns2.push({
      Name: "Designation",
      Value: "Architect"
    });

    WFInstances.push({
      InstanceId: 2,
      columns: Columns2
    });



    BusinessProcessInstanceStateDatas.push({ DataCaption: "TradingCounterparty", DataType: "Text Box", Value: "", ItemSource: [] });
    BusinessProcessInstanceStateDatas.push({ DataCaption: "Counterparty Type", DataType: "Drop Down", Value: "", ItemSource: [{ ID: 1, Name: "Bank" }, { ID: 2, Name: "Legal Entity" }] });
    BusinessProcessInstanceStateDatas.push({ DataCaption: "Established Date", DataType: "Date", Value: "", ItemSource: [] });
    BusinessProcessInstanceStateDatas.push({ DataCaption: "Comments", DataType: "Rich Text Box", Value: "", ItemSource: [] });


  }

  getTimeEntryLines() {
    return lines;
  }

  getCompanies() {
    return companies;
  }

  getWFInstances() {
    return WFInstances;
  }

  getBusinessProcessInstanceStateDatas() {
    return BusinessProcessInstanceStateDatas;
  }

  getWorkFlowTabs(): WorkFlowTab[] {
    return WorkFlowTabs;
  }
}
